import React from 'react';
import './Loader.css';

export enum LoaderSize {
    small = 'small',
    medium = 'medium',
}
interface loaderPropps {
    size: LoaderSize;
    show: boolean;
    className?: string;
    id?:string
}
export function Loader(props: loaderPropps) {
    const className = props.className ?? '';
    const loader = () => {
        return props.show ? (
            <div auto-id={props.id} data-testid={props.id}  className={`overflow ${className}`}>
                <span data-testid='inner-span'  className={`inner ${props.size}`}></span>
                <span data-testid='outer-span' className={`outer ${props.size}`}></span>
            </div>
        ) : null;
    };
    return loader();
}
